import figma from '../../assets/stacklogo/figma.svg'

export default function FigmaLogo(){
    return(
        <img src={figma} alt="" srcset="" />
    )
}